import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { lookupMed } from 'helpers/medicationHelpers';
import MedicationHistoryList from './MedicationHistoryList';
//import chevLeft from 'icons/chevron-left-24.png';
import ConfirmModal from 'components/common/ConfirmModal';
import { getCurrentUserId, setMedsHistoryLoaded } from 'store/storeValtio';
import { deleteMedicationHistoryInDb } from 'store/localDb';
import Header from 'components/navigation/Header';

export default function MedicationHistory(props) {
  const [popup, setPopup] = useState({
    show: false,
    confirm: 'Delete',
    title: 'tempName',
    content: null,
    id: null,
  });
  const params = useParams();
  const medId = params.id;
  const med = lookupMed(medId);
  const navigate = useNavigate();
  //console.log('MedicationHistory', medId);

  useEffect(() => {
    if (window.startup) window.startup();
    return () => {
      if (window.shutdown) window.shutdown();
    }
  }, [])

  // This will show the Cofirmation Box

  function clearHistory() {
    const mn = medId ? med.name : "All Medications";
    console.log('clearHistory', mn);
    setPopup({ 
      show: true, 
      confirm: 'Delete',
      title: mn, 
      content: 'Are you sure you want to delete all these history items?', 
      id: medId
    });
    //setIsOpen(true);
  };

  // This will perform the deletion and hide the Confirmation Box

  const handleDeleteTrue = () => {
    //console.log('handleDeleteTrue', popup);
    handleDeleteHist(popup.id);
  };

  // This will just hide the Confirmation Box when user clicks "No"/"Cancel"

  const handleDeleteFalse = () => {
    //console.log('handleDeleteFalse');
    setPopup({ show: false, title: null, content:null, id: null });
  };

  async function handleDeleteHist(mid) {
    //console.log('handleDeleteHist', mid);
    await deleteMedicationHistoryInDb(getCurrentUserId(), mid);
    setMedsHistoryLoaded(false);
    setPopup({ show: false, taken: null, id: null });
  }

  function summarize() {
    navigate('/historySummary/' + medId)
  }

  return (
    <div className='mcard'>
      <ConfirmModal
        open={popup.show} 
        confirmButton={popup.confirm}
        onConfirm={()=>handleDeleteTrue()}
        onCancel={()=>handleDeleteFalse()}
        title={popup.title}
        content={popup.content}
        />

      <Header title='History' help='Historylist' />
      {medId && 
      <div className='mcard-header'>
          <div className='p-2 font-bold text-2xl text-left'>
            {med.name}
          </div>
          {/* <button
            className='plainBtn text-xl text-white bg-red-700'
            onClick={()=>clearHistory()}
            >
            Clear History
          </button> */}
          <button
            className='plainBtn text-xl text-white bg-red-700'
            onClick={()=>summarize()}
            >
            Summarize
          </button>
      </div>
      }
      {/* <div className='mcard-header'>Medication History</div> */}
      <div id='scroll_area' className='lcard mb-1'>
        <MedicationHistoryList medId={medId} />
        <div style={{ height: '60px' }} />
      </div>
    </div>
  );
}
